const FOOTER_LINKS = [
  {
    title: '关于我们',
    links: [
      { label: '平台介绍', href: '#about' },
      { label: '编辑团队', href: '#about' },
      { label: '加入我们', href: '#contact' },
      { label: '广告合作', href: '#contact' },
    ],
  },
  {
    title: '内容频道',
    links: [
      { label: '明星八卦', href: '#index' },
      { label: '综艺影视', href: '#index' },
      { label: '网红达人', href: '#index' },
      { label: '国际吃瓜', href: '#index' },
    ],
  },
  {
    title: '帮助支持',
    links: [
      { label: '常见问答', href: '#faq' },
      { label: '内容举报', href: '#contact' },
      { label: '隐私政策', href: '#faq' },
      { label: '用户协议', href: '#faq' },
    ],
  },
  {
    title: '关注我们',
    links: [
      { label: '新浪微博', href: '#footer' },
      { label: '微信公众号', href: '#footer' },
      { label: '抖音号', href: '#footer' },
      { label: '小红书', href: '#footer' },
    ],
  },
];

const PARTNERS = ['合作伙伴一', '合作伙伴二', '合作伙伴三', '合作伙伴四', '合作伙伴五', '合作伙伴六'];

export default function Footer() {
  const handleNavClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-background-900 text-foreground-300">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto py-12 md:py-16">
        <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-5 gap-8 mb-10">
          <div className="col-span-2 sm:col-span-1 lg:col-span-1">
            <a
              href="#hero"
              onClick={(e) => {
                e.preventDefault();
                handleNavClick('#hero');
              }}
              className="inline-block font-heading text-2xl text-white mb-3"
            >
              52吃瓜网
            </a>
            <p className="text-xs text-foreground-400 leading-relaxed mb-4">
              国内领先的泛娱乐八卦资讯聚合平台，覆盖明星、综艺、影视、网红等多领域，每日实时更新，满足你的吃瓜需求。联系我们：tips@52chigua.com
            </p>
            <div className="flex items-center gap-2">
              <a href="#footer" className="w-8 h-8 flex items-center justify-center rounded-lg bg-foreground-800 text-foreground-300 hover:bg-primary-500 hover:text-white transition-colors">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#footer" className="w-8 h-8 flex items-center justify-center rounded-lg bg-foreground-800 text-foreground-300 hover:bg-primary-500 hover:text-white transition-colors">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#footer" className="w-8 h-8 flex items-center justify-center rounded-lg bg-foreground-800 text-foreground-300 hover:bg-primary-500 hover:text-white transition-colors">
                <i className="ri-tiktok-line text-sm"></i>
              </a>
              <a href="#footer" className="w-8 h-8 flex items-center justify-center rounded-lg bg-foreground-800 text-foreground-300 hover:bg-primary-500 hover:text-white transition-colors">
                <i className="ri-bilibili-line text-sm"></i>
              </a>
            </div>
          </div>

          {FOOTER_LINKS.map((col) => (
            <div key={col.title}>
              <h4 className="text-sm font-medium text-white mb-3">{col.title}</h4>
              <ul className="space-y-2">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      onClick={(e) => {
                        e.preventDefault();
                        handleNavClick(link.href);
                      }}
                      className="text-xs text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-foreground-800 pt-8">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4 mb-6">
            <h4 className="text-sm font-medium text-white">合作伙伴</h4>
            <div className="flex flex-wrap items-center gap-3 justify-center">
              {PARTNERS.map((p, i) => (
                <span key={i} className="text-xs text-foreground-500 px-3 py-1 rounded-full bg-foreground-800/50 whitespace-nowrap">
                  {p}
                </span>
              ))}
            </div>
          </div>
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-foreground-500">
            <p>&copy; {new Date().getFullYear()} 52吃瓜网 All rights reserved.</p>
            <p>本站内容仅供娱乐参考，不构成任何建议</p>
          </div>
        </div>
      </div>
    </footer>
  );
}